import React from 'react';

const style  = {
  borderRadius: '50%',
  width: '15px',
  height: '15px',
  position: 'relative',
  marginLeft:'10px',
  borderTop: '3px solid rgba(0, 0, 0, 0.1)',
  borderRight: '3px solid rgba(0, 0, 0, 0.1)',
  borderBottom: '3px solid rgba(0, 0, 0, 0.1)',
  borderLeft: '3px solid #818a91',
  transform: 'translateZ(0)',
  display:'inline-block',
  animation: 'loading-spinner 0.5s infinite linear',
};
const hidestyle  = {
    borderRadius: '50%',
    width: '15px',
    height: '15px',
    position: 'relative',
    borderTop: '3px solid rgba(0, 0, 0, 0.1)',
    borderRight: '3px solid rgba(0, 0, 0, 0.1)',
    borderBottom: '3px solid rgba(0, 0, 0, 0.1)',
    borderLeft: '3px solid #818a91',
    transform: 'translateZ(0)',
    animation: 'loading-spinner 0.5s infinite linear',
    display :'none'
  };

export default class ButtonSpinner extends React.Component {
  render() {
      var currentStyle = this.props.IsLoading? style : hidestyle;

    return (
      <div className="loading-spinner" style={currentStyle}>
        <style>
        {`
        @keyframes loading-spinner {
          0% { transform : rotate(0deg); }
          100% { transform : rotate(360deg); }
        }
        `}
        </style>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ButtonSpinner.js